import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

/**
 * @deprecated Legacy icon.
 * */
function InsuranceIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 34 43">
      <path fill="currentColor" d="M32.6 5.613a2.162 2.162 0 011.398 2.026L34 25.471c0 3.474-1.811 6.644-5.545 9.933-1.898 1.671-4.038 3.188-7.648 5.536l-1.169.758-.98.636-.486.316a2.138 2.138 0 01-2.337.004 1635.515 1635.515 0 00-1.48-.96c-4.67-3.02-6.706-4.436-8.811-6.29C1.81 32.114 0 28.944 0 25.47V7.637C0 6.725.567 5.92 1.408 5.61L16.25.137a2.121 2.121 0 011.49-.003l14.623 5.392.237.087zM30.997 8.22L16.998 3 3 8.219v17.263c0 2.525 1.385 4.976 4.514 7.762 1.93 1.72 3.87 3.082 8.342 6.006A1605.044 1605.044 0 0017 40l.172-.113.965-.633 1.145-.75c3.444-2.264 5.466-3.714 7.203-5.26C29.615 30.458 31 28.007 31 25.482L30.998 8.22zM14 27.564v-2.212h1.946v-10.14H14V13h6.706v2.212h-1.967v10.14h1.967v2.212H14z"/>
    </SvgIcon>
  )
}
export default InsuranceIcon
